import { useEffect, useRef } from "react";

// Keep children/portal destination mounted while hidden: opening settings must
// never tear down a playing source or discard a draft URL.
export const SettingsDrawer = ({ open, onClose, children }) => {
  const panel = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement;
    panel.current?.querySelector("button")?.focus({ preventScroll: true });
    const onKeyDown = (e) => {
        if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); close.current(); }
        if (e.key === "Tab") {
          const items = [...panel.current.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href], [tabindex="0"]')];
          const first = items[0], last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
        }
    };
    const node = panel.current;
    node.addEventListener("keydown", onKeyDown);
    return () => { node.removeEventListener("keydown", onKeyDown); previous?.focus?.({ preventScroll: true }); };
  }, [open]);
  return (
    <div className="settings-backdrop" hidden={!open} onMouseDown={(e) => { if (e.target === e.currentTarget) close.current(); }}>
      <section className="settings-drawer" ref={panel} role="dialog" aria-modal="true" aria-label="賽事與影片設定">
        <div className="dialog-heading"><h2>賽事與影片設定</h2><button type="button" aria-label="關閉設定" onClick={onClose}>返回影片</button></div>
        {children}
      </section>
    </div>
  );
};
